//
// PortablePackage.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "./moduleBuilder";
import ClosetObject from "./ClosetObject";

var PortablePackage = createModule("commons::PortablePackage", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getSupportedLocales: [[7]],
        getName: [7],
        getBundleNames: [[7]],
        getRelativeAssetPaths: [[7]],
        getBundlePaths: [[7],7,7],
        initialize: [4],
    },
    {
        getRegisteredPackages: [[1]],
        getVersion: [7],
        getAllBundlePaths: [[7],7],
    },
    ,
]);
export default PortablePackage;
